// Model-chain resolution for managed agents.
//
// Pure function — derives the primary/secondary/tertiary model ids for an
// agent from its /host/refresh payload, applying the precedence
// agent override > org default > platform default. No I/O, no manager-module
// dependencies, so it is a leaf importable by any subsystem (scheduler,
// lifecycle, processAgent all resolve the chain). See ADR-0011.

export function resolveModelChain(refreshData: Record<string, unknown>): { primary?: string; secondary?: string; tertiary?: string } {
  const agent = refreshData.agent as Record<string, unknown> | undefined;
  const modelDefaults = refreshData.model_defaults as { platform?: Record<string, unknown> | null; org?: Record<string, unknown> | null } | undefined;
  const platform = modelDefaults?.platform ?? {};
  const org = modelDefaults?.org ?? {};

  function resolve(tier: 'primary' | 'secondary' | 'tertiary'): string | undefined {
    const agentField = `${tier}_model`;
    const platformField = `default_${tier}_model`;

    // 1. Agent override
    const agentVal = agent?.[agentField] as string | undefined;
    if (agentVal) return agentVal;

    // 2. Org default
    const orgVal = org?.[platformField] as string | undefined;
    if (orgVal) return orgVal;

    // 3. Platform default
    const platformVal = platform?.[platformField] as string | undefined;
    if (platformVal) return platformVal;

    return undefined;
  }

  return {
    primary: resolve('primary'),
    secondary: resolve('secondary'),
    tertiary: resolve('tertiary'),
  };
}
